import { useSessionPermission } from '@btime/react-session'
import { path } from 'ramda'
import React from 'react'

import { usePdfOptionsForm } from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import LabelValue from '../../../../components/pdf/LabelValue'
import Gallery from '../../../../components/pdf/Gallery'
import { isObject } from 'lodash'

const CustomFields = ({ serviceOrder }) => {
  const { hideConfidentialInfo } = usePdfOptionsForm()
  const canSeeConfidentialFields = useSessionPermission('seeConfidentialFields')
  let fieldValues = serviceOrder?.fieldValues || []

  fieldValues =
    !canSeeConfidentialFields || hideConfidentialInfo
      ? fieldValues.filter(fieldValue => !path(['field', 'configuration', 'confidential'], fieldValue))
      : fieldValues

  if (!fieldValues.length) return false

  const getFieldValueByType = value => {
    return isObject(value) ? value?.name : value
  }

  // TODO - That wat gallery component may not be the bastway to present images
  // TODO - Create a Qrcode to present may work better
  return (
    <>
      {fieldValues.map((fieldValue, index) =>
        fieldValue?.field?.type === 'gallery' ? (
          <Gallery items={fieldValue.value} key={index} />
        ) : (
          <LabelValue
            key={fieldValue.id}
            label={fieldValue.field?.name}
            value={getFieldValueByType(fieldValue.value)}
          />
        )
      )}
    </>
  )
}

export default CustomFields
